import PropTypes from 'prop-types';


export const ProductPropType = PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
});

export const BasketPropType = PropTypes.shape({
    details: PropTypes.shape({
        id: PropTypes.number.isRequired,
        shipping_price: PropTypes.shape({
            currency: PropTypes.string.isRequired,
            excl_tax: PropTypes.string.isRequired,
            incl_tax: PropTypes.string.isRequired,
            tax: PropTypes.string.isRequired,
        }).isRequired,
    }),
});

export const LinesPropType = PropTypes.arrayOf(PropTypes.shape({
    product: PropTypes.shape({
        id: PropTypes.number.isRequired,
    }),
}));

export const CategoryProps = {
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
};

export const CategoryShape = PropTypes.shape({
    ...CategoryProps,
});

export const RootCategoryProps = {
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    children: PropTypes.arrayOf(CategoryShape).isRequired,
};

export const RootCategoryShape = PropTypes.shape({
    ...CategoryProps,
    children: PropTypes.arrayOf(CategoryShape).isRequired,
});



// WEBPACK FOOTER //
// ./src/utils/propTypes.js